import React from 'react';
import { NavLink } from 'react-router-dom';
import { FiHome, FiSettings, FiPlusSquare } from 'react-icons/fi';
import styles from './BottomNav.module.css';
import { FormattedMessage } from 'react-intl'; // <--- Импорт

const BottomNav = () => {
    return (
        <nav className={styles.navWrapper}>
            <NavLink
                to="/"
                className={({ isActive }) =>
                    isActive ? `${styles.navItem} ${styles.active}` : styles.navItem
                }
                end // Для точного совпадения корневого пути
            >
                <FiHome />
                <FormattedMessage id="nav.home" />
            </NavLink>
            <NavLink
                to="/create"
                className={({ isActive }) =>
                    isActive ? `${styles.navItem} ${styles.active}` : styles.navItem
                }
            >
                <FiPlusSquare />
                <FormattedMessage id="nav.create" />
            </NavLink>
            <NavLink
                to="/settings"
                className={({ isActive }) =>
                    isActive ? `${styles.navItem} ${styles.active}` : styles.navItem
                }
            >
                <FiSettings />
                <FormattedMessage id="nav.settings" />
            </NavLink>
        </nav>
    );
};

export default BottomNav;
